import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import { Table } from "antd";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import { getAllColumns } from "./AllColumnsData";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const moduleNames = ["Child Custody Considerations", "Holiday Arrangements"];

export default function ChildCustodyConsiderations() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Child Custody Considerations");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();
  console.log("formDatrat", formData);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  console.log("Attributes Data:", attributes);
  console.log("Disaster Attribures", disasterAttribute);

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  const collapsableTable = [{ title: "Holiday Arrangements", key: 1 }];

  const tableDataObj = {
    "Child Custody Considerations": tableData.childCustodyConsiderationsData,
    "Holiday Arrangements": tableData.holidayArrangementsData,
  };

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };

  const cleanedAttributes = Array.isArray(attributes)
    ? attributes
        .filter(
          (item) => item !== null && typeof item === "object" && item.attributes
        )
        .reduce((acc, curr) => {
          acc[curr.name] = curr.attributes;
          return acc;
        }, {})
    : {};

  // console.log("📦 handleFormDataUpdate - formdata to be set:", formData);

  // const handleFormDataUpdate = (formData) => {
  //   const Payload = {
  //     "Holiday Arrangements": formData && formData["Holiday Arrangements"],
  //   };
  //   console.log("📦 handleFormDataUpdate - Payload to be set:", Payload);

  //   setFormData((prev) => ({
  //     ...prev,
  //     ...Payload,
  //   }));
  // };

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
            <h2 className="parent-title">Child Custody Considerations</h2>
            <ToolTipCreator name={"Divorce_Child_Custody_Considerations"}/>
        </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>

       {disasterAttribute && (
              <>
                <DisabilityFormCreator
                  data={disasterAttribute}
                  values={disasterAttributeData}
                  setSubmitBody={setFormData}
                  setModuleName={setModuleName}
                />
                {console.log("DisasterData:", disasterAttributeData)}
      
                <div className="handle-submit-button-container">
                  <button
                    className="submit-button"
                    onClick={async () => {
                      if (toUpdate) {
                        await updateRecord();
                      } else {
                        if (formData && Object.keys(formData).length > 0) {
                          await createAttributes();
                        }
                      }
                    }}
                  >
                    {toUpdate ? "Update" : "Submit"}
                  </button>
                </div>
              </>
            )}
      
      {collapsableTable.map((table) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          createAttributes={createAttributes}
          onClick={() => showModal(table.title)}
          // handleFormDataUpdate={handleFormDataUpdate}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <CustomModal
        show={isModalVisible}
        fields={attributesData && attributesData}
        modalTitle={modalTitle}
        close={handelCloseModal}
        onChange={handleChange}
        onSelectChange={handleItemsInfoSelect}
        submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
        selectedRowData={formData}
        handleItemsInfoImageChange={formData}
        loading={loading}
      />
      <NewLoader isLoading={loading} />
    </div>
  );
}
